<form
  (submit)="onSubmit($event)"
  class="search-form"
  [attr.aria-label]="'raccourcis.rechercher' | translate"
>
  <input
    type="text"
    matInput
    name="search"
    role="searchbox"
    placeholder="{{ 'raccourcis.rechercher-mots-cles' | translate }}"
    autocomplete="off"
    floatLabel="never"
    [(ngModel)]="search"
    class="search-input"
    id="searchInput"
    [attr.aria-label]="'raccourcis.rechercher-mots-cles' | translate"
    matTooltip="{{ 'raccourcis.conseil-recherche' | translate }}"
    matTooltipPosition="below"
    matTooltipClass="search-tooltip"
    matTooltipShowDelay="300"
  />
  <button 
    type="submit" 
    [attr.aria-label]="'raccourcis.rechercher' | translate"
    class="button-search"
  >
    <mat-icon matSuffix class="search-icon">search</mat-icon>
  </button>
</form>
